import { format, utcToZonedTime } from 'date-fns-tz';
import { isValid } from 'date-fns';
import { enUS, ja } from 'date-fns/locale';
import { formatDefault } from '@/filters/formatDefault';
import { i18n } from '@/plugins/i18n';
import { DateOptionTypes } from '@/types/types';

/**
 * @description format a given date to default or specific date time format
 *
 * @param val string, date to be formatted
 * @param options object to define the format, and time display in locale or utc
 *
 * @return formatted date time string or default format.
 */
export const formatDateTime = (val?: string | null, options?: DateOptionTypes) => {
  if (!val || !isValid(new Date(val))) {
    return formatDefault(val);
  }
  const timeFormat = options?.format || 'yyyy-MM-dd HH:mm';

  // https://date-fns.org/v2.12.0/docs/Locale
  const locale = i18n.locale === 'ja' ? ja : enUS;

  if (options?.localTime) {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone?.toString() || 'Asia/Tokyo';
    // https://github.com/marnusw/date-fns-tz#readme
    return format(utcToZonedTime(new Date(val), timeZone), timeFormat);
  }
  // need to explicitly have a utc dateTime so it doesn't get transformed into local
  const utcDateTime = utcToZonedTime(new Date(val), 'UTC');
  // https://date-fns.org/v2.11.0/docs/format
  return format(utcDateTime, timeFormat, { timeZone: 'UTC', locale });
};
